import { queryOptions, type UseQueryOptions } from '@tanstack/react-query';
import type {
  GetOwnUserProfileData,
  GetUserProfileResponse,
} from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';

export const getMyProfileKey = () => ['profiles', '@me'] as const;

const getMyProfileUrl: GetOwnUserProfileData['url'] = 'profiles/@me';

export const getMyProfileOptions = <T = GetUserProfileResponse>(
  options?: Omit<
    UseQueryOptions<GetUserProfileResponse, unknown, T>,
    'queryKey' | 'queryFn'
  >,
) =>
  queryOptions<GetUserProfileResponse, unknown, T>({
    queryKey: getMyProfileKey(),
    queryFn: () =>
      PrivateApi.get(getMyProfileUrl).json<GetUserProfileResponse>(),
    ...options,
  });
